import styled from "styled-components";
import { colors } from "constants/colors";
import { BasicSectionContainer } from "../../../../../style";
import { styleSizes } from "constants/styleSizes";

export const AddGuestInfoContainer = styled(BasicSectionContainer)`
  .accountBody {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-items: stretch;
    gap: 32px;

    .room {
      font-size: 24px;
      font-weight: 600;
      margin: 0;
      padding: 0 0 32px 0;
    }

    .roomOptions {
      display: flex;
      flex-direction: row;
      gap: 16px 64px;
      margin-bottom: 32px;
      @media only screen and (max-width: ${styleSizes.miniBreakpoint}) {
        gap: 16px 48px;
      }

      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        flex-wrap: wrap;
        gap: 16px 64px;
      }
      .roomType,
      .roomFeatures {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
      .roomFeaturesNumberOfKeys{
        flex: 1;
        align-items: flex-end;
        @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
            flex-basis: 100%;
            align-items: flex-start;
            margin-top: 16px;
        }
      }
      .optionTitle {
        font-size: 14px;
        font-weight: 400;
        white-space: nowrap;
      }
      .optionContent {
        font-size: 16px;
        font-weight: 600;
      }
    }
    .roomForm {
      .formBody {
        display: flex;
        flex-direction: row;
        gap: 23px;
        @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
          flex-direction: column;
          gap: 0;
        }
        .phoneCel {
          flex: 244;
          @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
            max-width: 244px;
          }
          @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
            max-width: none;
          }
        }
        .nameCel {
          flex: 340;
          @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
            max-width: 340px;
          }
          @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
            max-width: none;
          }
        }
        .numberOfKeysCel {
          flex: 160;
          display: flex;
          flex-direction: row;
          gap: 8px;
          margin-top: 25px;
          margin-bottom: 21px;
        }
      }
      .formControls {
        margin-top: 11px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
          justify-content: flex-start;
        }
        @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
          justify-content: flex-end;
        } 
      }
    }

    .warning {
      width: 100%;
      height: 20px;
      line-height: 20px;
      position: absolute;
      color: ${colors.red};
      font-size: 14px;
      font-weight: 600;
      white-space: normal;
      overflow: visible;
      text-overflow: unset;
      text-align: left;
      margin-top: 5px;
    }
  }
`;
